/**
 * 자산 관련 데이터를 중앙에서 관리하는 Pinia 스토어
 * 예수금, 증거금, 총 자산을 관리합니다.
 *
 * 주의: useOrderDataStore가 있는 경우 totalProfitLoss를 사용하고,
 * 없는 경우 내부 profitLoss를 사용합니다.
 */
import { useOrderDataStore } from '../order/useOrderDataStore';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
export const useAssetStore = defineStore('asset', () => {
    const depositBalance = ref(0);
    const marginBalance = ref(0);
    const profitLoss = ref(0); // useOrderDataStore가 없을 때 사용
    /**
     * 예수금과 증거금을 업데이트합니다.
     * 웹소켓 체결 데이터에서 호출됩니다.
     */
    const updateBalance = (deposit, margin) => {
        depositBalance.value = deposit;
        marginBalance.value = margin;
    };
    /**
     * 예수금만 업데이트합니다.
     * 웹소켓 입출금 데이터에서 호출됩니다.
     */
    const setDepositBalance = (deposit) => {
        depositBalance.value = deposit;
    };
    /**
     * 평가 손익을 설정합니다.
     * useOrderDataStore가 없을 때 사용합니다.
     */
    const setProfitLoss = (pl) => {
        profitLoss.value = pl;
    };
    /**
     * 읽기 전용 데이터
     */
    const depositBalanceComputed = computed(() => depositBalance.value);
    const marginBalanceComputed = computed(() => marginBalance.value);
    /**
     * 총 자산 계산
     * useOrderDataStore가 있으면 totalProfitLoss를 사용하고,
     * 없으면 내부 profitLoss를 사용합니다.
     *
     * 자산총액 = 예탁자산(예수금) + P/L
     */
    const totalAssets = computed(() => {
        try {
            // useOrderDataStore의 totalProfitLoss 사용
            const orderDataStore = useOrderDataStore();
            if (orderDataStore && orderDataStore.totalProfitLoss !== undefined) {
                return depositBalance.value + orderDataStore.totalProfitLoss;
            }
        }
        catch (error) {
            // useOrderDataStore가 없거나 에러가 발생하면 내부 profitLoss 사용
            // (스토어가 아직 초기화되지 않았을 수 있음)
        }
        // 기본값: 내부 profitLoss 사용
        return depositBalance.value + profitLoss.value;
    });
    /**
     * 자산 데이터 초기화
     * 로그아웃 시 호출하여 모든 자산 데이터를 초기 상태로 되돌립니다.
     */
    const resetAssetData = () => {
        depositBalance.value = 0;
        marginBalance.value = 0;
        profitLoss.value = 0;
    };
    return {
        depositBalanceComputed,
        marginBalanceComputed,
        updateBalance,
        setDepositBalance,
        setProfitLoss,
        resetAssetData,
        totalAssets,
    };
});
//# sourceMappingURL=useAssetStore.js.map